var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDescriptionicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 15H11.75M5.75 12H11.75M9.75038 1.00087C9.65484 1 9.54738 1 9.42471 1H4.9502C3.83009 1 3.26962 1 2.8418 1.21799C2.46547 1.40973 2.15973 1.71547 1.96799 2.0918C1.75 2.51962 1.75 3.08009 1.75 4.2002V15.8002C1.75 16.9203 1.75 17.4801 1.96799 17.9079C2.15973 18.2842 2.46547 18.5905 2.8418 18.7822C3.26921 19 3.829 19 4.94694 19L12.5531 19C13.671 19 14.23 19 14.6574 18.7822C15.0337 18.5905 15.3405 18.2842 15.5322 17.9079C15.75 17.4805 15.75 16.9215 15.75 15.8036V7.32568C15.75 7.20302 15.7499 7.09553 15.749 7M9.75038 1.00087C10.0358 1.00348 10.2157 1.01407 10.3882 1.05547C10.5923 1.10446 10.7879 1.18526 10.9668 1.29492C11.1686 1.41857 11.3418 1.59181 11.6875 1.9375L14.813 5.06298C15.1589 5.40889 15.3309 5.58136 15.4546 5.78319C15.5642 5.96214 15.6453 6.15726 15.6943 6.36133C15.7357 6.53379 15.7464 6.71454 15.749 7M9.75038 1.00087L9.75 3.80021C9.75 4.92031 9.75 5.48015 9.96799 5.90797C10.1597 6.2843 10.4655 6.59048 10.8418 6.78223C11.2692 7 11.829 7 12.9469 7H15.749",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescriptionicon);
export default __webpack_public_path__ + "static/media/descriptionicon.2d11cd3c30b2d15b893fa3e25fe4bdf7.svg";
export { ForwardRef as ReactComponent };